module.exports = __webpack_public_path__ + "assets/tick.e9508c4e.svg";